module.exports = __webpack_public_path__ + "static/media/APP_Ranger_152x174_1-01.873d4bd7.png";